import { isNavigationFailure, useRouter } from 'vue-router'

import axios from 'axios'

const config = { isEnabled: true }

const state = {
  userId: null,
  events: [],
}

// Axios local instance.
const iterableApi = axios.create({
  baseURL: 'https://api.eu.iterable.com',
})

const iterableEndpoints = {
  trackEvent: '/api/events/track',
}

function setApiKey (apiKey) {
  iterableApi.defaults.headers.common['api-key'] = apiKey
}

async function track (eventName, data = {}) {
  if (!eventName) throw new Error('An event name should be provided')

  const { isEnabled } = config
  const { eventId, userId, dataFields } = data

  if (!isEnabled) return

  const eventData = {
    eventName,
    eventId,
    dataFields,
    createdAt: Math.floor(Date.now() / 1000), // Unix timestamp.
  }

  state.events.push(eventData)

  if (userId) {
    state.userId = userId

    while (state.events.length > 0) {
      const event = state.events.shift()
      try {
        await iterableApi.post(iterableEndpoints.trackEvent, {
          ...event,
          userId,
        })

        await new Promise(resolve => setTimeout(resolve, 250))
      } catch (err) {
        console.error(err)
      }
    }
  }
}

function trackPageViews () {
  const router = useRouter()

  router.afterEach((to, from, failure) => {
    if (isNavigationFailure(failure)) return

    if (config.excludedPathNames?.some(pathName => RegExp(pathName).test(to.name))) return

    const pageLocation = location ? location.href : `${config.baseURL || ''}${to.fullPath}`

    track('page_view', {
      userId: state.userId,
      dataFields: {
        pageName: to.name,
        pageLocation,
      },
    })
  })
}

function installPlugin (app, options = {}) {
  const { apiKey, ...otherOptions } = options
  if (!apiKey) throw new Error('Iterable Api-Key is required')

  setApiKey(apiKey)

  Object.assign(config, otherOptions)

  if (config.pageTracking) trackPageViews()

  app.provide('iterable', this)
}

export default {
  install: installPlugin,
  track,
}
